import { FunctionComponent, h } from 'preact';
import { useMemo } from 'preact/hooks';
import { TaskPhase } from '@bringg/types';
import { lazy, Suspense } from 'preact/compat';
import Loading from '../../../components/loading/loading';
import ErrorPage from '../../../pages/error-page/error-page';

const OptInPage = lazy(() => import('../../../pages/opt-in-page/opt-in-page'));
const UserDeliveryConfiguration = lazy(
	() => import('../../../components/user-delivery-configuration/user-delivery-configuration')
);

interface Props {
	taskPhase: TaskPhase;
}

const CustomerExperienceContent: FunctionComponent<Props> = ({ taskPhase }) => {
	const content = useMemo(() => {
		switch (taskPhase) {
			case TaskPhase.SCHEDULING:
				return <UserDeliveryConfiguration />;
			case TaskPhase.SCHEDULED:
				return <OptInPage />;
			default:
				return <ErrorPage />;
		}
	}, [taskPhase]);

	return <Suspense fallback={<Loading />}>{content}</Suspense>;
};

export default CustomerExperienceContent;
